import React from 'react';
import PropTypes from 'prop-types';
import TextCallout2 from "../../textComponents/TextCallout2";
import * as ToolTipUI from "./ToolTip.styles";

var ToolTip = function ToolTip(_ref) {
  var closeAction = _ref.closeAction,
      data = _ref.data,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'right' : _ref$direction;
  var imgSrc = data.imgSrc,
      imgIcon = data.imgIcon,
      heading = data.heading,
      description = data.description,
      buttonLink = data.buttonLink,
      buttonText = data.buttonText,
      buttonOnClick = data.buttonOnClick;

  var clickAction = function clickAction() {
    if (buttonOnClick) {
      buttonOnClick();
    }

    closeAction();
  };

  return /*#__PURE__*/React.createElement(ToolTipUI.Container, {
    direction: direction
  }, imgSrc && /*#__PURE__*/React.createElement("img", {
    src: imgSrc,
    width: "60px",
    height: "60px",
    alt: "Profilbild illustration"
  }), imgIcon, /*#__PURE__*/React.createElement(ToolTipUI.Close, {
    width: 25,
    height: 25,
    onClick: closeAction
  }), /*#__PURE__*/React.createElement(ToolTipUI.Heading, null, heading), description && /*#__PURE__*/React.createElement(TextCallout2, null, description), buttonText && /*#__PURE__*/React.createElement(ToolTipUI.ActionButton, {
    type: "secondary",
    href: buttonLink && buttonLink,
    size: "small",
    onClick: clickAction
  }, buttonText));
};

ToolTip.propTypes = process.env.NODE_ENV !== "production" ? {
  closeAction: PropTypes.func,
  data: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    description: PropTypes.string,
    buttonText: PropTypes.string,
    buttonLink: PropTypes.string,
    buttonOnClick: PropTypes.func,
    imgSrc: PropTypes.string,
    imgIcon: PropTypes.node
  }),
  direction: PropTypes.string
} : {};
export default ToolTip;
//# sourceMappingURL=ToolTip.js.map